import React from 'react';
import Icon from '../../../components/AppIcon';

const TeacherCard = ({ teacher }) => {
  return (
    <div className="bg-card rounded-lg shadow-warm p-6 text-center hover:shadow-lg transition-smooth">
      <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center">
        <Icon name="User" size={48} color="var(--color-primary)" />
      </div>

      <h3 className="text-lg font-semibold text-foreground mb-1">{teacher.name}</h3>
      <p className="text-primary text-sm font-medium mb-3">{teacher.specialization}</p>
      <p className="text-muted-foreground text-sm mb-4">{teacher.bio}</p>

      <div className="space-y-2 text-sm mb-4">
        <div className="flex items-center justify-center gap-2">
          <Icon name="Award" size={16} color="var(--color-primary)" />
          <span className="text-foreground">{teacher.experience}</span>
        </div>
        <div className="flex items-center justify-center gap-2">
          <Icon name="Users" size={16} color="var(--color-primary)" />
          <span className="text-foreground">{teacher.studentsCount} students taught</span>
        </div>
      </div>

      <div className="flex items-center justify-center gap-1">
        {[...Array(5)].map((_, i) => (
          <Icon
            key={i}
            name="Star"
            size={14}
            color={i < teacher.rating ? 'var(--color-primary)' : 'var(--color-border)'}
          />
        ))}
        <span className="text-xs text-muted-foreground ml-2">{teacher.rating}/5</span>
      </div>
    </div>
  );
};

export default TeacherCard;
